// @flow
import Axios from 'axios'
import moment from 'moment'
import {getCookie} from '../../utils/common';
import ApiService from '../apiService'
const apiUrl = getCookie('apiUrl') || 'https://api.optionsedu.com/graphql'

// Data
export const UPDATE_PORTFOLIO_DATA = 'portfolio:updatePortfolioSnapshot'
export type UPDATE_PORTFOLIO_DATA_TYPE = {
  type: 'portfolio:updatePortfolioSnapshot',
  payload: { portfolioSnapshot: Object[] }
}

export const updatePortfolioSnapshot = (portfolioSnapshot: Object[]): UPDATE_PORTFOLIO_DATA_TYPE => ({
  type: UPDATE_PORTFOLIO_DATA,
  payload: { portfolioSnapshot }
})

// Fetching & Error
export const UPDATE_PORTFOLIO_STATUS = 'portfolio:updatePortfolioStatus'
export type UPDATE_PORTFOLIO_STATUS_TYPE = {
  type: 'portfolio:updatePortfolioStatus',
  payload: {
    isFetching: boolean,
    error: null | string
  }
}

export const updatePortfolioStatus = (isFetching: boolean, error: null | string): UPDATE_PORTFOLIO_STATUS_TYPE => ({
  type: UPDATE_PORTFOLIO_STATUS,
  payload: {
    isFetching,
    error
  }
})

export const getPortfolioSnapshot = async (dispatch: Function, account) => {

  // set fetching
  dispatch(updatePortfolioStatus(true, null))

  // GraphQL
  // const query = {
  //   query: `{
  //     portfolio {
  //       portfolioSnapshot {
  //         tradeID
  //         name
  //         openDate
  //         closedDate
  //         strategy
  //         symbols
  //         profit
  //         transactions {
  //           tradeDate
  //           quantity
  //           symbol
  //           underlying
  //           assetType
  //           expiration
  //           strike
  //           price
  //           transactionGroup
  //           mark
  //         }
  //       }
  //     }
  //   }`
  // }
  //
  // const CONTENT_TYPE = { 'Content-Type': 'application/x-www-form-urlencoded' }

  // Axios.post(apiUrl, query, { headers: CONTENT_TYPE })
  //   .then((res: Object) => {
  //
  //     // set fetching false and add data
  //     dispatch(updatePortfolioStatus(false, null));
  //     dispatch(updatePortfolioSnapshot(res.data.data.portfolio.portfolioSnapshot));
  //   })
  //   .catch((err: Object) => {
  //
  //     // set fetching false and add error
  //     dispatch(updatePortfolioStatus(false, 'Unable to Get Risk Portfolio'));
  //   })
  
  const data = {
    'Account': account || 'all'
  }
  
  const response = await ApiService.getTrades(data);
  if (response) {
    dispatch(updatePortfolioStatus(false, null));
    dispatch(updatePortfolioSnapshot(response));
  } else {
    dispatch(updatePortfolioStatus(false, 'Unable to Get Risk Portfolio'));
  }
  
}

export const getMarketPrices = (symbols) => {
  
    let subQuery = '';
    symbols.forEach((symbol) => {
      subQuery += `
      ${symbol.s}: optionQuote(optionSymbol: "${symbol.s}", onDate: "${moment(symbol.d).format('YYYY-MM-DD')}") {
                  multiplier
                  underlyingPrice
                  ask
                  bid
                }
      `
    });
  
    const query = {
          query: `{
            securities {
              options {
               ${subQuery}
              }
            }
         }`
    }
  
  const CONTENT_TYPE = { 'Content-Type': 'application/x-www-form-urlencoded' }
  
  return Axios.post(apiUrl, query, { headers: CONTENT_TYPE });
}



// WEBPACK FOOTER //
// ./src/actions/portfolios/index.js